import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Gérant / responsable — silhouette avec coche d'autorité duotone */
export const ManagerIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pastille check menthe (badge d'autorité) */}
      <circle cx="18" cy="6" r="3.5" fill="var(--equiply-icon-bg)" />
      <path
        d="M16.5 6l1 1 2-2"
        stroke="hsl(var(--background))" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Tête */}
      <circle cx="10" cy="9" r="3.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Buste */}
      <path
        d="M3.5 20.5c0-3.5 3-6 6.5-6s6.5 2.5 6.5 6"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
ManagerIcon.displayName = "ManagerIcon";
